/*
 * @Author: your name
 * @Date: 2020-04-29 08:21:58
 * @LastEditTime: 2021-07-21 11:35:03
 * @LastEditors: pangting
 * @Description: In User Settings Edit
 * @FilePath: \CoreWeb\packages\Web\test-web\src\main.ts
 */
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App.vue'
// import store from './vuex/store'
import router from "./router"
import { initCommonRouter, initIView, initFilter, initPolyfill, initGlobal, initAxios, store } from "@newview/base-web"
import iView from 'view-design'
import Element from 'element-ui';
import nvui from "@newview/ui";
import ant from "ant-design-vue";
import './style/iconfont.css';

// 全局引入
Vue.use(ant);
Vue.use(iView);
Vue.use(Element);
Vue.use(nvui);
initIView();
initFilter();
initPolyfill();
initGlobal();
initAxios(router);

initCommonRouter(router);
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App)
})
